import { render } from "./OuterProjects.vue?vue&type=template&id=bd7ffb02&scoped=true"
import script from "./OuterProjects.vue?vue&type=script&lang=js"
export * from "./OuterProjects.vue?vue&type=script&lang=js"

import "./OuterProjects.vue?vue&type=style&index=0&id=bd7ffb02&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7ffb02"]])

export default __exports__